import { Area, AreaChart, ResponsiveContainer } from 'recharts';

import { STATIC_ASSET_BASE_URL } from '@/utility/constants';

import NextImage from '@/components/common/NextImage';

type CommunityVisitsChartProps = {
  visitsPerDay: number[];
};

export const CommunityVisitsChart = ({
  visitsPerDay
}: CommunityVisitsChartProps) => {
  const data = visitsPerDay.map((visits, index) => ({
    name: `Day ${index + 1}`,
    uv: visits
  }));

  const isDownwardTrend =
    visitsPerDay[0] > visitsPerDay[visitsPerDay.length - 1];
  const stopColor = isDownwardTrend ? '#F04438' : '#FFCE00';

  const isEmpty = visitsPerDay.length === 0;

  if (isEmpty) {
    return (
      <div className="h-44 w-full relative px-16">
        <div className="relative w-full h-44 overflow-hidden">
          <NextImage
            mobileImgProps={{
              src: `${STATIC_ASSET_BASE_URL}/nasIO/common/png/empty-chart.png`,
              alt: 'Empty state image',
              layout: 'fill',
              objectFit: 'cover'
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={44}>
      <AreaChart data={data} margin={{ right: 24, left: 24, bottom: 0 }}>
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="10%" stopColor={stopColor} stopOpacity={0.3} />
            <stop offset="90%" stopColor={stopColor} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey="uv"
          stroke={stopColor}
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
